exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n.checkbox {\n  display: inline-flex;\n  cursor: pointer;\n  font-family: Roboto;\n  font-weight: 400;\n  text-align: start;\n  color: #25b8d2; }\n\n.checkbox__input {\n  display: none; }\n\n.checkbox__icon {\n  flex-shrink: 0;\n  border-radius: 3px;\n  border: 1px solid currentColor;\n  color: currentColor;\n  background-color: #fff; }\n\n.checkbox__label {\n  max-width: 100%;\n  color: #444; }\n\n.checkbox--disabled {\n  opacity: 0.5;\n  pointer-events: none; }\n  .checkbox--disabled .checkbox__icon {\n    background-color: transparent; }\n\n.checkbox__input:focus ~ .checkbox__icon {\n  border: 1px solid #c2c2c2;\n  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 5px 0 rgba(0, 0, 0, 0.16); }\n\n.checkbox__input:not(:checked):not(:indeterminate) ~ .checkbox__icon {\n  border: 1px solid #ddd;\n  color: transparent; }\n\n/* Sizes\n   ========================================================================== */\n.checkbox--small {\n  padding: 7px 0; }\n  .checkbox--small .checkbox__icon {\n    width: 12px;\n    height: 12px;\n    padding: 1px; }\n  .checkbox--small .checkbox__label {\n    padding-right: 6px;\n    max-width: calc(100% - 12px);\n    font-size: 12px;\n    line-height: 16px; }\n  .checkbox--small .checkbox__icon + .checkbox__label {\n    padding-left: 6px;\n    padding-right: 0; }\n\n.checkbox--medium {\n  padding: 9px 0; }\n  .checkbox--medium .checkbox__icon {\n    width: 18px;\n    height: 18px;\n    padding: 3px; }\n  .checkbox--medium .checkbox__label {\n    padding-right: 8px;\n    max-width: calc(100% - 18px);\n    font-size: 14px;\n    line-height: 22px; }\n  .checkbox--medium .checkbox__icon + .checkbox__label {\n    padding-left: 8px;\n    padding-right: 0; }\n\n.checkbox--large {\n  padding: 11px 0; }\n  .checkbox--large .checkbox__icon {\n    width: 22px;\n    height: 22px;\n    padding: 5px; }\n  .checkbox--large .checkbox__label {\n    padding-right: 10px;\n    max-width: calc(100% - 22px);\n    font-size: 16px;\n    line-height: 28px; }\n  .checkbox--large .checkbox__icon + .checkbox__label {\n    padding-left: 10px;\n    padding-right: 0; }\n\n.checkbox--x-large {\n  padding: 15px 0; }\n  .checkbox--x-large .checkbox__icon {\n    width: 25px;\n    height: 25px;\n    padding: 5px; }\n  .checkbox--x-large .checkbox__label {\n    max-width: calc(100% - 25px);\n    padding-right: 15px;\n    font-size: 20px;\n    line-height: 30px; }\n  .checkbox--x-large .checkbox__icon + .checkbox__label {\n    padding-left: 15px;\n    padding-right: 0; }\n\n/* Align items\n   ========================================================================== */\n.checkbox--align-flex-start {\n  align-items: flex-start; }\n\n.checkbox--align-center {\n  align-items: center; }\n\n.checkbox--align-flex-end {\n  align-items: flex-end; }\n\n.checkbox--align-baseline {\n  align-items: baseline; }\n\n.checkbox--align-stretch {\n  align-items: stretch; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};